import * as React from 'react';
type IconQuienesSomosProps = React.SVGProps<SVGSVGElement>;

export const IconQuienesSomos: React.FC<IconQuienesSomosProps> = (props) => (
<svg width={15} height={32} viewBox="0 0 15 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M11.201 16.0014C9.327 12.9173 7.43156 10.3365 7.43156 10.3365C7.43156 10.3365 5.5388 12.9173 3.66211 16.0014C5.5388 19.0829 7.43156 21.6636 7.43156 21.6636C7.43156 21.6636 9.32432 19.0829 11.201 16.0014Z" fill="#EBF8F0"/>
<path d="M11.2013 16.0013C9.32726 19.0828 7.43182 21.6635 7.43182 21.6635C7.43182 21.6635 5.53906 19.0828 3.66237 16.0013C1.82315 19.0265 0 22.5363 0 24.5683C0 28.6724 3.32772 32.0001 7.43182 32.0001C11.5359 32.0001 14.8636 28.6724 14.8636 24.5683C14.8636 22.5363 13.0405 19.0265 11.1986 15.9987L11.2013 16.0013Z" fill="#7EAE90"/>
<path d="M7.43182 0C3.32772 0 0 3.32772 0 7.43182C0 9.46379 1.82315 12.9736 3.66504 16.0014C5.54174 12.9173 7.4345 10.3365 7.4345 10.3365C7.4345 10.3365 9.32726 12.9173 11.204 16.0014C13.0432 12.9762 14.869 9.46647 14.869 7.43182C14.8636 3.32772 11.5359 0 7.43182 0Z" fill="#FFA692"/>
</svg>




);
export default IconQuienesSomos;
